import {css, view} from '@sail/ui/deprecated';
import {Attachment} from './Attachment';
import {AttachmentPreview} from './AttachmentPreview';

type AttachmentPreviewListProps = {
  attachments: Attachment[];
  onRemoveAttachment: (attachment: Attachment) => void;
};

export const AttachmentPreviewList = ({
  attachments,
  onRemoveAttachment,
}: AttachmentPreviewListProps): JSX.Element | null => {
  if (attachments.length === 0) {
    return null;
  }

  return (
    <view.ul
      css={{
        borderRadius: 'medium',
        marginTop: 'medium',
        marginBottom: 'medium',
        backgroundColor: css.value('$backgroundColor.container'),
        paddingLeft: 'small',
        paddingRight: 'small',
      }}
    >
      {attachments.map((attachment, i) => (
        <view.li
          key={attachment.id}
          css={{
            listStyle: css.value('none'),
            borderBottom:
              i < attachments.length - 1
                ? css.value('$space.1 solid $borderColor.neutral')
                : css.value('none'),
          }}
        >
          <AttachmentPreview
            attachment={attachment}
            onRemoveAttachment={onRemoveAttachment}
          />
        </view.li>
      ))}
    </view.ul>
  );
};
